import React, { Fragment } from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'

import { Section, Row, Column, Rows } from '@/components/layout'
import { Icon } from '@/components/common'
import trackReceiptsApp from '@/assets/track-receipts/track-receipts-mobile-app.jpg'

import styles from './MobileAppFeatures.module.scss'

const MobileAppFeatures = ({ title, image, appFeatures }) => (
  <Section className={styles.mobileAppFeatures} paddingTop={0}>
    <Rows>
      <Row center>
        <h2 className="text-center">{title}</h2>
      </Row>
      <Row className={styles.mobileAppFeaturesRow}>
        <Column alignCenter className={styles.featuresImage} textCenter>
          <Image
            alt=""
            src={image || trackReceiptsApp}
            style={{ width: 'auto' }}
          />
        </Column>
        <Column className={styles.featuresList}>
          {appFeatures.map((feature) => (
            <Fragment key={feature.description}>
              <p className={styles.description}>
                <Icon fill="success" name="check" />
                {feature.description}
              </p>
              {feature.moreInfo && (
                <p>{feature.moreInfo}</p>
              )}
            </Fragment>
          ))}
        </Column>
      </Row>
    </Rows>
  </Section>
)

MobileAppFeatures.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  appFeatures: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    moreInfo: PropTypes.string,
  })),
}

export default MobileAppFeatures
